import update from 'react-addons-update';
import {
	REGISTER_INIT_SUCCESS,
	REGISTER_CLEAR,
	REGISTER_POST_SUBAGENT_SUCCESS,
	REGISTER_UPDATE_AGENT_INFO,
	REGISTER_POST_ERROR,
	REGISTER_CLEAR_ERROR
} from './action.js';

const initState = {
	action: null,
	agentInfo: null,
	addressInfo: null,
	errors: null,
	showSuccessDialog: false
};

export default function registerReducer(state = initState, action) {
	switch (action.type) {
		case REGISTER_INIT_SUCCESS:
			let initAgentInfo = {},
				initAddressInfo = {};

			if (action.data) {
				// 組合 子帳號註冊資訊
				initAgentInfo = {
					lock: false,
					organizationCode: action.data.organizationCode,
					agentStatus: '',
					mainAgentName: action.data.agentName,
					agentName: '',
					agentType: '',
					preferredCurrency: action.data.preferredCurrency,
					preferredLanguage: '',
					title: '',
					firstName: '',
					lastName: '',
					mobilePhone: {
						id: null,
						number: '',
						dialCode: ''
					},
					workPhone: {
						id: null,
						number: '',
						dialCode: ''
					},
					email: '',
					confirmEmail: '',
					address1: '',
					address2: '',
					city: '',
					addressState: 'OTH',
					country: '',
					postalCode: '',
					password: '',
					confirmPassword: '',
				};

				// 組合 主帳號地址資訊
				initAddressInfo = {
					address1: action.data.address1,
					address2: action.data.address2,
					city: action.data.city,
					addressState: action.data.addressState || 'OTH',
					country: action.data.country,
					postalCode: action.data.postalCode
				};
			}

			return update(state, {
				agentInfo: { $set: initAgentInfo },
				addressInfo: { $set: initAddressInfo }
			});
		case REGISTER_POST_SUBAGENT_SUCCESS:
			return update(state, {
				showSuccessDialog: { $set: true }
			});
		case REGISTER_UPDATE_AGENT_INFO:
			return update(state, {
				agentInfo: { $set: action.data }
			});
		case REGISTER_POST_ERROR:
      return update(state, {
        errors: { $set: action.errors }
      });
    case REGISTER_CLEAR_ERROR:
      return update(state, {
        errors: { $set: initState.errors }
      });
		case REGISTER_CLEAR:
			return initState;
		default:
			return state;
	}
}